/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { IncidenciaModelDto } from '../models/incidencia-model-dto';
import { incidenciasControllerEnviarIncidencia } from '../fn/paciente-incidencias/incidencias-controller-enviar-incidencia';
import { IncidenciasControllerEnviarIncidencia$Params } from '../fn/paciente-incidencias/incidencias-controller-enviar-incidencia';
import { incidenciasControllerObtencionIncidencias } from '../fn/paciente-incidencias/incidencias-controller-obtencion-incidencias';
import { IncidenciasControllerObtencionIncidencias$Params } from '../fn/paciente-incidencias/incidencias-controller-obtencion-incidencias';

@Injectable({ providedIn: 'root' })
export class PacienteIncidenciasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `incidenciasControllerObtencionIncidencias()` */
  static readonly IncidenciasControllerObtencionIncidenciasPath = '/api/incidencias/obtener-incidencias';

  /**
   * Obtener incidencia.
   *
   * Obtiene una incidencia del paciente especificado
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidenciasControllerObtencionIncidencias()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidenciasControllerObtencionIncidencias$Response(params?: IncidenciasControllerObtencionIncidencias$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IncidenciaModelDto>>> {
    return incidenciasControllerObtencionIncidencias(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener incidencia.
   *
   * Obtiene una incidencia del paciente especificado
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `incidenciasControllerObtencionIncidencias$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  incidenciasControllerObtencionIncidencias(params?: IncidenciasControllerObtencionIncidencias$Params, context?: HttpContext): Observable<Array<IncidenciaModelDto>> {
    return this.incidenciasControllerObtencionIncidencias$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<IncidenciaModelDto>>): Array<IncidenciaModelDto> => r.body)
    );
  }

  /** Path part for operation `incidenciasControllerEnviarIncidencia()` */
  static readonly IncidenciasControllerEnviarIncidenciaPath = '/api/incidencias/enviar-incidencia';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidenciasControllerEnviarIncidencia()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidenciasControllerEnviarIncidencia$Response(params: IncidenciasControllerEnviarIncidencia$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return incidenciasControllerEnviarIncidencia(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `incidenciasControllerEnviarIncidencia$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidenciasControllerEnviarIncidencia(params: IncidenciasControllerEnviarIncidencia$Params, context?: HttpContext): Observable<void> {
    return this.incidenciasControllerEnviarIncidencia$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
